import { NavLink } from 'react-router-dom'
import { Briefcase, Wallet, User, Wifi, WifiOff } from 'lucide-react'
import { ROUTES } from '@/config/routes'
import useAuthStore from '@/stores/authStore'

const NAV = [
  { to: ROUTES.WORKER_HOME,     icon: Briefcase, label: 'Jobs'     },
  { to: ROUTES.WORKER_EARNINGS, icon: Wallet,    label: 'Earnings' },
  { to: '/profile',             icon: User,      label: 'Profile'  },
]

export default function WorkerLayout({ children, available }) {
  const profile = useAuthStore((s) => s.profile)

  return (
    <div className="min-h-dvh bg-surface-base flex flex-col">

      {/* ── Top bar ─────────────────────────────────────────────────────────── */}
      <header className="bg-surface-raised border-b border-surface-border px-4 py-3 flex items-center justify-between safe-top shrink-0">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 bg-siglat-teal/15 rounded-lg flex items-center justify-center shrink-0">
            <span className="text-siglat-teal text-xs font-black">SK</span>
          </div>
          <div>
            <p className="text-sm font-bold text-ink-primary leading-none">Siglat Konstract</p>
            <p className="text-[10px] text-ink-muted">{profile?.full_name ?? 'Worker'}</p>
          </div>
        </div>

        {available !== undefined && (
          <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-semibold border
            ${available
              ? 'text-siglat-teal bg-siglat-teal/10 border-siglat-teal/25'
              : 'text-ink-muted bg-surface-overlay border-surface-border'}`
          }>
            {available ? <Wifi className="w-3 h-3" /> : <WifiOff className="w-3 h-3" />}
            {available ? 'Available' : 'Offline'}
          </div>
        )}
      </header>

      {/* ── Main content ────────────────────────────────────────────────────── */}
      <main className="flex-1 overflow-y-auto pb-20">
        {children}
      </main>

      {/* ── Bottom nav ──────────────────────────────────────────────────────── */}
      <nav className="fixed bottom-0 inset-x-0 z-30 bg-surface-raised border-t border-surface-border flex safe-bottom">
        {NAV.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === ROUTES.WORKER_HOME}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center gap-0.5 py-2.5 text-[10px] font-medium transition-colors
              ${isActive ? 'text-siglat-teal' : 'text-ink-muted'}`
            }
          >
            <Icon className="w-5 h-5" />
            {label}
          </NavLink>
        ))}
      </nav>

    </div>
  )
}
